export default __webpack_public_path__ + "static/givingBackToNature-4b6c4218e259a10c9944611bbf40e8bd.webp";